import React, { useMemo } from "react";
import { CustomTableVirtuoso } from "../shared/table";
import { Complement } from "./domain/Complement";
import { HandleInputChangeRequest, UpdatedARIValue, ValueTypes } from "../shared/types";
import { ComplementData } from "../shared/domain/ComplementData";
import { AriType } from "../updateForm";
import { usePropertyConfiguration } from "../../../components/property-configuration-provider";

interface Props {
  items: ComplementData[];
  handleQuickUpdate: (
    ticker: string,
    valueType: ValueTypes,
    type: AriType
  ) => void;
  enableEdition: boolean;
  handleInputChange: (props: HandleInputChangeRequest) => void;
  updatedARIValues: UpdatedARIValue;
  showAltStyles: boolean;
  numberOfDays: number;
}

export const Complements = (
  {
    items,
    handleQuickUpdate,
    enableEdition,
    handleInputChange,
    updatedARIValues,
    numberOfDays,
    showAltStyles
  }: Props
): JSX.Element => {
  const complementsList = useMemo(() =>
    Object.values(items).map(it => Complement.of(it.ticker, it.dailySet)),
    [items]
  );

  return (
    <CustomTableVirtuoso
      items={complementsList}
      handleQuickUpdate={handleQuickUpdate}
      enableEdition={enableEdition}
      handleInputChange={handleInputChange}
      updatedARIValues={updatedARIValues}
      isComplement
      customHeight="93px"
      showAltStyles={showAltStyles}
      numberOfDays={numberOfDays}
    />
  );
};
